<template>
  <div class="app flex-row align-items-center">
    <div class="container">
      <b-row class="justify-content-center">
        <b-col md="8">
          <b-card-group>
            <b-card no-body class="p-4">
              <b-card-body>
                <b-form>
                  <h1>Login <span class="axl">(AdGenerator by AXL Media)</span></h1>
                  <p class="text-muted">Sign In to your account</p>
                  <b-input-group class="mb-3">
                    <b-input-group-prepend><b-input-group-text><i class="icon-email"></i></b-input-group-text></b-input-group-prepend>
                    <b-form-input type="email" class="form-control" placeholder="email" autocomplete="email" v-model="email" />
                  </b-input-group>
                  <b-input-group class="mb-4">
                    <b-input-group-prepend><b-input-group-text><i class="icon-lock"></i></b-input-group-text></b-input-group-prepend>
                    <b-form-input type="password" class="form-control" placeholder="Password" autocomplete="current-password" v-model="password" @keyup.enter="login" />
                  </b-input-group>
                  <b-row>
                    <b-col cols="6">
                      <b-button @click.prevent="login" variant="primary" class="px-4">Login</b-button>
                    </b-col>
                    <b-col cols="6" class="text-right">
                      <b-button variant="link" class="px-0">Forgot password?</b-button>
                    </b-col>
                  </b-row>
                </b-form>
              </b-card-body>
            </b-card>
            <!-- <b-card no-body class="text-white bg-primary py-5 d-md-down-none" style="width:44%">
              <b-card-body class="text-center">
                <div>
                  <h2>Sign up</h2>
                  <p>Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.</p>
                  <b-button variant="primary" class="active mt-3">Register Now!</b-button>
                </div>
              </b-card-body>
            </b-card> -->
          </b-card-group>
           <div class="alert alert-danger" role="alert" v-if="error">
                          Incorect username or password!
           </div>
        </b-col>
      </b-row>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Login',
  data () {
    return {
      email: '',
      password: '',
      error: '',
      api_url: ''
    }
  },
  methods: {
    login: function () {
      const email = this.email
      const password = this.password
      this.error = ''
      this.$store.dispatch('login', { email, password })
        .then(() => {
          this.$router.push('/')
        })
        .catch(err => {
          console.log(err)
          this.error = err
        })
    }
  },
  created () {
    this.api_url = this.$api_url
  }
}
</script>

<style scoped>
 .axl {
   font-size: 19px;
   color: lightgray;
   margin-left: 5px;
 }

</style>>
